import { LEAD_ENDPOINT } from '../constants/api';

export interface LeadPayload {
  name: string;
  email: string;
  school: string;
  phone: string;
}

/**
 * Отправляет заявку в central. Бросает Error с текстом от сервера,
 * чтобы форма показала причину (например, некорректный email).
 */
export const submitLead = async (payload: LeadPayload): Promise<void> => {
  const response = await fetch(LEAD_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.message || 'Не удалось отправить заявку');
  }
};
